module.exports = __webpack_public_path__ + "assets/images/circunference_g.2aaf162a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/circunference_g.png
// module id = 688
// module chunks = 1